export const STAGING_HOSTNAME = "dev-dashboard.legitimate.tech";

export const IS_STAGING =
  typeof window !== "undefined" &&
  window.location.hostname === STAGING_HOSTNAME;
